module.exports = __webpack_public_path__ + "cc7a445e407c662c09dbdb3882478046.svg";